import { useRefinementList } from 'react-instantsearch-core';

export const DummyFilterActivator = ({ attribute }: { attribute: string }) => {
  useRefinementList({ attribute });
  return null;
};
